





































import Tab from './components/Tab.vue';
import Tabs from './components/Tabs.vue';
import SerieNumeroFormGeneral from './SerieNumeroFormGeneral.vue';
import SerieNumeroFormDevolucionBodega from './SerieNumeroFormDevolucionBodega.vue';
import SerieNumeroFormSerieActiva from './SerieNumeroFormSerieActiva.vue';
import SerieNumeroFormMovimientoDispositivos from './SerieNumeroFormMovimientoDispositivos.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    Tab,
    Tabs,
    SerieNumeroFormGeneral,
    SerieNumeroFormDevolucionBodega,
    SerieNumeroFormSerieActiva,
    SerieNumeroFormMovimientoDispositivos,
  },
})
export default class SerieNumeroForm extends Vue {
  @Prop({ default: null }) serieNumeroSeleccionado: any;
  @Prop({ default: null }) tipoEquipoSeleccionado: any;
  @Prop({ default: null }) serieactivanroSeleccionado: any;
}
